import React, { useContext } from 'react'
import { Navigate, NavLink, useNavigate } from "react-router-dom";
import "../assets/header.css";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { solid, regular, brands, icon } from '@fortawesome/fontawesome-svg-core/import.macro' // <-- import styles to be used
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCoffee, faHome } from '@fortawesome/fontawesome-free-solid'
import User from '../Protected/context';
import { useCookies } from 'react-cookie';


function Header() {
    const [user, setUser] = useContext(User)
    const [cookies, setCookie, removeCookie] = useCookies(["g-pwd"])
    const navigate = useNavigate()

    return (
        <>
            <div className='header-container'>
                <div className='header-stable' onClick={() => {
                    navigate("/")
                }}>
                    <div className='main-logo'>Roamhome</div>
                    <div className='sub-logo'>Jetson Web</div>
                </div>
                <div className='navigation'>
                    <ul>
                        <li>
                            <NavLink
                                to="/"
                                className={({ isActive, isPending }) =>
                                    isPending ? "pending" : isActive ? "active" : ""
                                }
                            >
                                Upcoming
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/homes"
                                className={({ isActive, isPending }) =>
                                    isPending ? "pending" : isActive ? "active" : ""
                                }
                            >
                                Your Homes
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/payout"
                                className={({ isActive, isPending }) =>
                                    isPending ? "pending" : isActive ? "active" : ""
                                }
                            >
                                Payout
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/calendar"
                                className={({ isActive, isPending }) =>
                                    isPending ? "pending" : isActive ? "active" : ""
                                }
                            >
                                Calendar
                            </NavLink>
                        </li>
                    </ul>
                </div>
                <div className='auth'>
                    {user !== null && (
                        <>
                            <div className='auth-text'>


                                Logged in as {user.name}

                            </div>
                            <div className='logout'>
                                <button onClick={() => {
                                    removeCookie("g-pwd")
                                    setUser(null)
                                    navigate("/login")
                                }}>Logout?</button>
                            </div>
                        </>
                    )}
                </div>

            </div>
            {user !== null && (
                <div className='mobile-navigation'>
                    <ul>
                        <li>
                            <NavLink
                                to="/"
                                className={({ isActive, isPending }) =>
                                    isPending ? "pending" : isActive ? "active" : ""
                                }
                            >
                                Upcoming
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/homes"
                                className={({ isActive, isPending }) =>
                                    isPending ? "pending" : isActive ? "active" : ""
                                }
                            >
                                Your Homes
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/payout"
                                className={({ isActive, isPending }) =>
                                    isPending ? "pending" : isActive ? "active" : ""
                                }
                            >
                                Payout
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/calendar"
                                className={({ isActive, isPending }) =>
                                    isPending ? "pending" : isActive ? "active" : ""
                                }
                            >
                                Calendar
                            </NavLink>
                        </li>
                    </ul>
                </div>
            )}
        </>
    )
}

export default Header